import { Injectable } from '@angular/core';

import { Http, Headers, Response, RequestOptions,  } from '@angular/http';
import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class GolinksData {
  data: any;
  added_ids: any;

  constructor(public http: Http, public common: CommonData, public userData: UserData) {
    this.added_ids = [];
  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load() {
    /*
    if (this.data) {
      return Promise.resolve(this.data);
    }
    */
    // don't have the data yet
    return new Promise(resolve => {
      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'golinks/index?token='+this.userData.jwt).subscribe(res => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          //this.data = this.processData(res.json());
          this.data = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });

      }
    });
  }


  view(link_id) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          id: link_id
          ,token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'golinks/view',params).subscribe(res => {
          let data = res.json().data;
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer');
          //console.log(error);
      });

      }
    });
  }  

  generateURLIdent(){
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'golinks/urlident',params).subscribe(res => {
          let data = res.json().data;
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer');
          //console.log(error);
      });

      }
    });
  }

  create(golink) {
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        golink: golink
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'golinks/create',params)
        .subscribe(data => {          
          let response = data.json();
          //console.log(response);
          if(response.success === true){   
              this.added_ids.push(response.data.id);
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }    
  update(golink) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          id: golink.id
          ,golink: golink
          ,token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'golinks/update',params).subscribe(res => {
          let data = res.json();
          //console.log(data);
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer');
          //console.log(error);
      });

      }
    });

  }    
  delete(golink_id) {
    return new Promise(resolve => {
    });

  }    

}



// WEBPACK FOOTER //
// ./src/providers/golinks-data.ts